new Vue({
    el:'.summer26',
    data(){
        return {
            loadFlag:false,
            isLottery:true,
            sendFlag:false,
            submitFlag:false,
            popup:false,
            gamePopup:false,
            recordPopup:false,
            addressPopup:false,
            prizePopup:false,
            sharePopup:false,
            rulePopup:false,
            loginPopup:false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            findText:'',
            user:{
                name:'',
                email:'',
                code:'',
                country:'Country',
                invite_code:'',
                points:0,
                is_win:false,
                invite_num:0
            },
            address:{
                state:'',
                city:'',
                street:'',
                postal:'',
                phone:''
            },
            popup1:false,
            select_flag1:0,
            countryArr:[],
            pointsHistory:[],
            recordNav:['Chance Record','Winning Record'], 
            recordIndex:0,
            prizeName:localStorage.getItem('OXVA_summer_prize') || '',
            className:'',
            prizeAll:{
                XLIM_GO_LITE:false,
                XLIM_PRO_3:false,
                OXVA_Summer_Merch:false,
                OXVA_NEXLIM_2_2_MINI_Gift_Box:false,
                Lucky_Try:false,
            },
            winnerArr:[],
            // cards
            config: {
                // 中间最多同时显示几张卡片
                // 例如题库有 6 张，但页面上最多只露出 3 张
                visibleCount: 3,
            
                // 拖拽时卡片允许缩小到的最小比例
                // 0.7 表示最多缩小到原尺寸的 70%
                minScale: 0.7,

                originX:0,
                originY:0,
            
                // 卡片拖入 REAL / FAKE 区域时，区域缩小比例
                // 0.8 表示区域缩小到 80%
                dropHoverScale: 0.8,
            
                // 拖拽缩放的距离参考值
                // 数值越小，卡片缩小越快
                // 数值越大，卡片缩小越慢
                scaleDistance: 520,
            
                // 底部卡片随机角度的最小值
                // 只影响非最上层卡片
                backAngleMin: 12,
            
                // 底部卡片随机角度的最大值
                // 角度越大，底部卡片展开越明显
                backAngleMax: 26,
            
                // 最上层卡片随机角度最小值
                // 通常保持接近 0，避免主卡太歪
                topAngleMin: -3,
            
                // 最上层卡片随机角度最大值
                topAngleMax: 3,
            
                // 回弹动画时长，单位 ms
                // 数值越大，回弹越慢
                // 数值越小，回弹越快
                bounceDuration: 100
            },
            allQuestions: [
                {
                    id: 'card-1',
                    statement: 'Effortless wearing your NeXLIM 2 MINI to a music festival and dancing.',
                    correctChoice: 'REAL',
                    answer: 'The NeXLIM 2 MINI is 59g ONLY.',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/1_50a79550-0370-4b2e-a946-12e6cca8d841.avif?v=1786325377'
                },
                {
                    id: 'card-2',
                    statement: 'Vaping through an extended trip on one charge with the NeXLIM 2 MINI.',
                    correctChoice: 'REAL',
                    answer: 'The NeXLIM 2 MINI features 1500 mAh for up to 1 week in ECO mode.',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/2_5344c49c-f4ef-441b-9936-6d54ab2f9050.avif?v=1786325377'
                },
                {
                    id: 'card-3',
                    statement: 'Worrying about leaks from your NeXLIM 2 MINI in your travel bag.',
                    correctChoice: 'FAKE',
                    answer: 'The NeXLIM  cartridge (Unitech 3.0) is 3x more leak-resistant by Unitech 3.0.',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3_be588dad-cec3-4a81-a842-ab0525a67e70.avif?v=1786325377'
                },
                {
                    id: 'card-4',
                    statement: 'Tapping to switch modes on your NeXLIM 2 MINI at a beach club.',
                    correctChoice: 'REAL',
                    answer: 'Smart touch control makes the NeXLIM 2 MINI seamless.',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4_5e0c3618-c73a-4d85-9326-c1602471d77f.avif?v=1786325377'
                },
                {
                    id: 'card-5',
                    statement: 'Changing the NeXLIM  cartridge (Unitech 3.0) frequently while backpacking abroad.',
                    correctChoice: 'FAKE',
                    answer: '1 NeXLIM  cartridge (Unitech 3.0) supports up to 30 refills.',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/5_cddcbff9-f59e-4be9-b67b-42af278b222b.avif?v=1786325377'
                },
                {
                    id: 'card-6',
                    statement: "Betting friends the NeXLIM 2 MINI is plastic because it feels light.",
                    correctChoice: 'FAKE',
                    answer: 'The NeXLIM 2 MINI is premium aerospace-grade aluminum.',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/6_4e15b308-a99d-46ae-8c6a-24cbaecf835e.avif?v=1786325377'
                },
                {
                    id: 'card-7',
                    statement: 'Friends guessing your NeXLIM 2 MINI uses mini cartridges.',
                    correctChoice: 'FAKE',
                    answer: 'The NeXLIM 2 MINI shares the standard NeXLIM  cartridge (Unitech 3.0).',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/1_8406634d-72c8-4978-a9fb-391ff3559cdc.avif?v=1786325997'
                },
                {
                    id: 'card-8',
                    statement: 'Checking the NeXLIM 2 MINI battery at a dark campsite.',
                    correctChoice: 'REAL',
                    answer: 'The NeXLIM 2 MINI smart LED light shows power instantly.',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/2_ea3a4a6f-c520-470c-888b-ef4dd1e964c2.avif?v=1786325997'
                },
                {
                    id: 'card-9',
                    statement: 'Adjusting airflow blindly on a night stroll.',
                    correctChoice: 'REAL',
                    answer: 'The NeXLIM 2 MINI features 3-level precise airflow adjustment.',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3_3a0b3df8-0444-4236-97ca-9247d94aee3d.avif?v=1786325997'
                },
                {
                    id: 'card-10',
                    statement: 'Feeling weighed down holding the NeXLIM 2 MINI on a hike.',
                    correctChoice: 'FAKE',
                    answer: 'The NeXLIM 2 MINI is 59g, light as your earbud case.',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4_bec83ea8-2b0e-46c1-a2d5-e7fb0c7cfc6e.avif?v=1786325997'
                },
                {
                    id: 'card-11',
                    statement: 'Charging your NeXLIM 2 MINI while getting ready for work.',
                    correctChoice: 'REAL',
                    answer: "The NeXLIM 2 MINI features fast charge to 80% in just 30 min.",
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/5_e73f2103-b45c-4503-9103-b6b52a71512c.avif?v=1786325997'
                },
                {
                    id: 'card-12',
                    statement: 'Finding a button on the NeXLIM 2 MINI to vape while gaming intensely.',
                    correctChoice: 'FAKE',
                    answer: 'Auto-draw makes vaping the NeXLIM 2 MINI effortless.',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/6_8201ae7a-17cc-4f64-9ead-d5fa5564b60f.avif?v=1786325997'
                },
                {
                    id: 'card-13',
                    statement: 'Assuming this sleek metallic NeXLIM 2 MINI must be heavy.',
                    correctChoice: 'FAKE', 
                    answer: 'Aerospace-grade aluminum keeps the NeXLIM 2 MINI ultra-light.',
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/7_bd209d30-9616-41d5-aa6f-40784814a9fa.avif?v=1786325997'
                }
            ],
            // 当前轮次题目。每次开始游戏时，会从 allQuestions 中随机抽取 6 个生成到这里。
            questions: [],

            draggingId: '',
            bouncingId: '',
            hoverChoice: '',
            dragState: null,
            result: null,
            resultTimer: null,
            correctCount: 0,
            momoShaking: false
        }
    },
    computed: {
        /* 当前未完成题目，按顺序排队 */
        availableCards: function () {
            return this.questions
                .filter(function (item) {
                    return !item.selected;
                })
                .sort(function (a, b) {
                    return a.order - b.order;
                });
        },

        /* 当前最上层卡片 id */
        topCardId: function () {
            return this.availableCards.length ? this.availableCards[0].id : '';
        },

        topCard: function () {
            return this.availableCards.length
                ? this.availableCards[0]
                : null;
        },

        isFinished: function () {
            return this.questions.every(function (item) {
                return item.selected;
            });
        }
    },
    methods:{
        // 功能类-------------------------------------------------
        async submitAddress(){
            if(!this.address.state || !this.address.city || !this.address.street || !this.address.postal || !this.address.phone){
                return showMessage('Please fill in the information completely','error');
            } 

            //showMessage('Submitting, please wait...','success')
            //避免重复提交 
            if(this.submitFlag) return;
            this.submitFlag = true
            this.address.name = this.user.name
            this.address.email = this.user.email
            this.address.country = this.user.country

            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.address));
            let res = await axios.post('https://service.oxvatech.cn/summer/submitAddress',params, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                showMessage('Submission successful, preparing for shipment.','success')
            }else{
                let errorMessages = {
                    202: 'Ops, No winning information found.',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
            this.popup = this.addressPopup = this.submitFlag = false
        },
        async lottery(){
            if(!this.checkLogin()) return;
            if(!this.isLottery) return;
            if(this.user.chance<1){
                showMessage('Oops! No Spins Left.','error')
                return;
            }

            // 开始抽奖
            this.isLottery = false
            let res = await axios.post('https://service.oxvatech.cn/summer/lottery',{},{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.status == 200){
                var status = res.data.status
                if(status==200){
                    //中奖
                    this.prizeName = res.data.data
                    localStorage.setItem('OXVA_summer_prize', this.prizeName) //存储中奖信息;
                    //&、空格和短横线转为下划线
                    var str = res.data.data.replace(/[ &-]/g, '_').replace(/_+/g, '_');
                    this.prizeAll[str] = true
                    this.Spin()
                    this.getInfo()
                    this.getData() //更新中奖者
                }else if(status==202){
                    //未中奖
                    this.prizeAll.Lucky_Try = true
                    this.user.chance -= 1
                    this.Spin()
                }else{
                    this.isLottery = true
                    let errorMessages = {
                        201: 'Oops! No Spins Left.',
                        500:' Server error, please contact customer service',
                    };
                    showMessage(errorMessages[status] || 'Unknown error', 'error');
                }
            }else{
                showMessage('Server Error','error')
            }
        },
        async getChance(type){
            if(type=='Upload'){
                if(this.user.is_upload==1) return;
            }else if(type=='Share'){
                if(this.user.is_share==1) return;
            }
            let params=new URLSearchParams();
            params.append('action',type);
            let res = await axios.post('https://service.oxvatech.cn/summer/getChance',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status==200){
                this.getInfo() //更新积分记录
                showMessage("You've earned 1 extra spin!",'success')
            }
        },
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            if(this.sendFlag){
                showMessage('Sent, please try again in one minute.','success')
                setTimeout(() => {
                    this.sendFlag = false
                    this.sendText = 'Send code'
                }, 1000*60);
                return;
            }
            this.sendText = 'Has sent'
            this.sendFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/summer/sendEmail',params);
            if(res.data.status == 200){
                this.isSend = true
                showMessage('Email has been sent, please check.','success')
            }else{
                showMessage('Server error, please contact customer service','error')
            }
        },
        async loginActivity(){
            if(!this.isSend){
                showMessage('Please send the email verification code first','error')
                return;
            }
            if(!this.user.name || !this.user.email || this.user.country == 'Country' || !this.user.code){
                showMessage('Please fill in the information completely','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            //避免重复提交
            if(this.submitFlag) return;
            this.submitFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/summer/loginActivity',params);
            if(res.data.status == 200){
                this.setCookie('_OXVA_Cheers_to_good_times_',res.data.data,90)
                this.user.token = res.data.data
                showMessage('Good luck! ','success')
                this.popup = this.loginPopup = false
                this.getInfo()
            }else{
                let errorMessages = {
                    201: 'Email verification code error',
                    202: 'Username already exists',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
            this.submitFlag = false
        },
        async getInfo(){
            let res = await axios.post('https://service.oxvatech.cn/summer/getInfo', {}, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                if(res.data.data.arr1.length>0){
                    this.isLogin = true
                    this.user = res.data.data.arr1[0]
                   
                    const winner = this.winnerArr.find(item => item.name == this.user.name) || {};
                    this.prizeName = winner.prize || '';
                    this.address.state = winner.state || '';

                    // if(this.user.name == ''){}

                    //总积分记录
                    this.pointsHistory = res.data.data.arr2
                    
                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            }
        },
        async getData(){
            let res = await axios.get('https://service.oxvatech.cn/summer/getData')
            if(res.status == 200){
                this.winnerArr = res.data.data
                
                const winner = this.winnerArr.find(item => item.name == this.user.name) || {};
                this.prizeName = winner.prize || '';
                this.address.state = winner.state || '';
            }
        },
        async getCountry(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }
        },
        async finishGame(){
            if(this.user.is_add > 0) return;
            if(this.correctCount<5) return;
            let params=new URLSearchParams();
            params.append('action','Quiz');
            let res = await axios.post('https://service.oxvatech.cn/summer/getChance',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status==200){
                this.getInfo() //更新积分记录
                showMessage("You've earned 1 extra spin!",'success')
            }
        },
        // 控件类-------------------------------------------------
        async saveCanvas() {
            if (this.submitFlag) return;
            showMessage('Downloading, please wait. . .','success')
            this.submitFlag = true;
            
            const canvas = await html2canvas(this.$refs.container, {
                backgroundColor: null,
                useCORS: true,
                allowTaint: false
            })

            const link = document.createElement("a");
            link.download ="OXVA_Cheers_to_good_times.png";
            link.href = canvas.toDataURL("image/png");
            link.click();
            this.submitFlag = false;
        },
        showPopup(type){
            if(!this.checkLogin()) return;
            this.popup = this[type] = true;
        },
        checkLogin(){
            // if(!this.isLogin){
            //     this.popup = this.loginPopup = true;
            //     return false;
            // }
            // return true;
            showMessage('Event ended. Thanks for joining!','success');
            return false
        },
        endTips(){
            showMessage('Event ended. Thanks for joining!.','success')
        },
        emailUpdate(){
            if(this.isSend){
                this.isSend = false
                this.sendFlag = false
                this.sendText = 'Send code'
            }
        },
        // cards---------------------------------------------
        closeGame(){
            this.resetGame()
            this.popup = this.gamePopup = false
        },
        /* 初始化一局游戏 */
        initRound: function () {
            var self = this;
            var pickedQuestions = this.shuffleCopy(this.allQuestions).slice(0, 6);

            this.correctCount = 0;
            this.result = null;
            this.draggingId = '';
            this.bouncingId = '';
            this.hoverChoice = '';
            this.dragState = null;

            this.questions = pickedQuestions.map(function (item, index) {
                return {
                    id: item.id + '-round-' + Date.now() + '-' + index,
                    statement: item.statement,
                    correctChoice: item.correctChoice,
                    answer: item.answer,
                    order: index + 1,
                    angle: 0,
                    x: self.config.originX,
                    y: self.config.originY,
                    originX: self.config.originX,
                    originY: self.config.originY,
                    scale: 1,
                    selected: false,
                    selectedChoice: '',
                    visible: false,
                    img:item.img
                };
            });

            this.$nextTick(function () {
                self.initCardPositions();
                self.updateVisibleCards();
            });
        },
        initCardLayout() {
            this.$nextTick(() => {
                const cardList = this.$refs.cardList;
            
                if (!cardList || !cardList.length) {
                    console.warn('cardList 还没有渲染出来');
                    return;
                }
                const cardEl = cardList[0];
            
                this.config.cardWidth = cardEl.offsetWidth;
                this.config.cardHeight = cardEl.offsetHeight;
            });
        },
        initCardPositions: function () {
            var self = this;
            this.questions.forEach(function (card) {
                card.x = self.config.originX;
                card.y = self.config.originY;
                card.originX = self.config.originX;
                card.originY = self.config.originY;
            });
        },
        /* 设置卡片样式，队列第一张始终层级最高 */
        getCardStyle: function (card) {
            var index = this.availableCards.findIndex(function (item) {
                return item.id === card.id;
            });
            var zIndex = card.id === this.draggingId ? 1000 : (100 - index);

            return {
                left: card.x + 'px',
                top: card.y + 'px',
                zIndex: zIndex,
                '--card-angle': card.angle + 'deg',
                '--card-scale': card.scale
            };
        },
        /* 问题文案格式化：把重点红色词突出 */
        formatQuestion: function (text) {
            // 'an hour', 'exactly the draw', 'same 1500mAh battery'
            var keywords = [];
            var html = this.escapeHtml(text);

            keywords.forEach(function (keyword) {
                var reg = new RegExp(keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
                html = html.replace(reg, function (match) {
                    return '<span class="highlight">' + match + '</span>';
                });
            });

            return html;
        },
        escapeHtml: function (value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        },
        getPoint: function (event) {
            var source = event.touches && event.touches.length
                ? event.touches[0]
                : event.changedTouches && event.changedTouches.length
                    ? event.changedTouches[0]
                    : event;

            return {
                clientX: source.clientX,
                clientY: source.clientY
            };
        },
        chooseByButton:function(choice){
            if(!this.checkLogin()) return;
            if(this.result) return;
        
            var card=this.topCard;
        
            if(!card) return;
        
            this.selectCard(card,choice);
        
        },
        closeResult() {
            clearTimeout(this.resultTimer);
            this.result = null;
            if (this.isFinished) {
                // console.log("游戏结束");
                this.popup=this.gamePopup=true
                if(this.correctCount>4){
                    this.finishGame()
                }
            }
        },
        startDrag: function (event, card) {
            if(!this.checkLogin()) return;

            if (this.result || card.id !== this.topCardId || card.selected || this.canPlay) {
                return;
            }

            var point = this.getPoint(event);
            var stageRect = this.$refs.cardsStage.getBoundingClientRect();

            this.draggingId = card.id;
            this.bouncingId = '';
            this.hoverChoice = '';
            card.scale = 1;

            this.dragState = {
                id: card.id,
                offsetX: point.clientX - stageRect.left - card.x,
                offsetY: point.clientY - stageRect.top - card.y
            };
        },
        onDragMove: function (event) {
            if (!this.dragState) {
                return;
            }

            if (event.cancelable) {
                event.preventDefault();
            }

            var point = this.getPoint(event);
            var card = this.getCardById(this.dragState.id);
            var boundaryRect = this.$refs.dragBoundary.getBoundingClientRect();
            var stageRect = this.$refs.cardsStage.getBoundingClientRect();

            /*
                卡片坐标相对于 cardsStage，拖拽边界相对于 dragBoundary。
                这里允许 x 为负数，确保卡片能拖到左侧 REAL 区。
            */
            var nextX = point.clientX - stageRect.left - this.dragState.offsetX;
            var nextY = point.clientY - stageRect.top - this.dragState.offsetY;
            var minX = boundaryRect.left - stageRect.left;
            var minY = boundaryRect.top - stageRect.top;
            var maxX = boundaryRect.right - stageRect.left - this.config.cardWidth;
            var maxY = boundaryRect.bottom - stageRect.top - this.config.cardHeight;

            card.x = this.clamp(nextX, minX, maxX);
            card.y = this.clamp(nextY, minY, maxY);

            this.hoverChoice = this.getChoiceByPoint(point);

            /* 拖拽缩放 */
            var dx = card.x - card.originX;
            var dy = card.y - card.originY;
            var distance = Math.sqrt(dx * dx + dy * dy);
            var scale = 1 - distance / this.config.scaleDistance * (1 - this.config.minScale);
            card.scale = this.clamp(scale, this.config.minScale, 1).toFixed(3);
        },
        endDrag: function (event) {
            if (!this.dragState) {
                return;
            }

            var point = this.getPoint(event);
            var card = this.getCardById(this.dragState.id);
            var choice = this.getChoiceByPoint(point);

            this.dragState = null;
            this.draggingId = '';
            this.hoverChoice = '';

            if (choice) {
                this.selectCard(card, choice);
            } else {
                this.bounceBack(card);
            }
        },
        /* 选择 REAL / FAKE 后 */
        selectCard: function (card, choice) {
            var self = this;
            var isCorrect = choice === card.correctChoice;

            card.selected = true;
            card.selectedChoice = choice;

            if (isCorrect) {
                this.correctCount += 1;
            }

            window.clearTimeout(this.resultTimer);

            this.result = {
                id: card.id,
                choice: choice,
                correctChoice: card.correctChoice,
                isCorrect: isCorrect,
                answer: card.answer
            };

            // 卡片先消失，再补出下一张。结果显示期间禁止继续拖拽。
            window.setTimeout(function () {
                card.scale = 1;
                card.x = card.originX;
                card.y = card.originY;
                self.updateVisibleCards();
            }, 180);

            // 2 秒后清空结果，左右区域恢复默认蓝色。
            this.resultTimer = window.setTimeout(function () {
                //self.result = null;
                self.closeResult();
            }, 2000);
        },
        /* 未拖入左右区域时回弹 */
        bounceBack: function (card) {
            var self = this;

            // 回弹开始时，底部两张随机变角度
            this.randomizeBackCards();
            this.bouncingId = card.id;
            card.scale = 1;

            this.$nextTick(function () {
                card.x = card.originX;
                card.y = card.originY;
            });

            window.clearTimeout(card._bounceTimer);
            card._bounceTimer = window.setTimeout(function () {
                self.bouncingId = '';
                card.scale = 1;
                card.x = card.originX;
                card.y = card.originY;
            }, this.config.bounceDuration + 30);
        },
        /* 更新当前可见卡片，最多显示 3 张 */
        updateVisibleCards: function () {
            var visibleIds = this.availableCards
                .slice(0, this.config.visibleCount)
                .map(function (item) {
                    return item.id;
                });

            this.questions.forEach(function (card) {
                card.visible = visibleIds.indexOf(card.id) !== -1;
                card.x = card.originX;
                card.y = card.originY;
                card.scale = 1;
            });

            this.randomizeBackCards();
        },
        /* 随机调整卡片角度： 1. 顶层卡片角度较小，便于阅读。 2. 底部两张每张独立随机正负角度。 */
        randomizeBackCards: function () {
            var self = this;
            var visibleCards = this.availableCards.slice(0, this.config.visibleCount);

            visibleCards.forEach(function (card, index) {
                if (index === 0) {
                    card.angle = self.randomAngle(self.config.topAngleMin, self.config.topAngleMax);
                    return;
                }

                var absAngle = self.randomAngle(self.config.backAngleMin, self.config.backAngleMax);
                var direction = Math.random() > 0.5 ? 1 : -1;
                card.angle = absAngle * direction;
            });
            // 新增
            self.shakeMomo();
        }, 
        shakeMomo: function () {

            var self = this;
        
            self.momoShaking = false;
        
            this.$nextTick(function(){
        
                self.momoShaking = true;
        
                clearTimeout(self._momoTimer);
        
                self._momoTimer = setTimeout(function(){
        
                    self.momoShaking = false;
        
                },350);
        
            });
        
        },
        getChoiceByPoint: function (point) {
            if (this.isPointInCircle(point, this.$refs.dropReal)) {
                return 'REAL';
            }

            if (this.isPointInCircle(point, this.$refs.dropFake)) {
                return 'FAKE';
            }

            return '';
        },
        isPointInCircle: function (point, el) {
            var rect = el.getBoundingClientRect();
            var centerX = rect.left + rect.width / 2;
            var centerY = rect.top + rect.height / 2;
            var radius = rect.width / 2;
            var dx = point.clientX - centerX;
            var dy = point.clientY - centerY;

            return Math.sqrt(dx * dx + dy * dy) <= radius;
        },
        getCardById: function (id) {
            return this.questions.find(function (item) {
                return item.id === id;
            });
        },
        randomAngle: function (min, max) {
            return Math.round((Math.random() * (max - min) + min) * 10) / 10;
        },
        clamp: function (value, min, max) {
            return Math.min(Math.max(value, min), max);
        },
        shuffleCopy: function (list) {
            var copied = list.slice();

            for (var i = copied.length - 1; i > 0; i -= 1) {
                var j = Math.floor(Math.random() * (i + 1));
                var temp = copied[i];
                copied[i] = copied[j];
                copied[j] = temp;
            }

            return copied;
        },
        resetGame: function () {
            window.clearTimeout(this.resultTimer);
            this.initRound();
        },
        // 工具类-------------------------------------------------
        formatISOToDateTime(isoString) {
            var date = new Date(isoString);
          
            // 转为北京时间（+8小时）
            date.setHours(date.getHours());
          
            var pad = (n) => n.toString().padStart(2, '0');
            var year = date.getFullYear();
            var month = pad(date.getMonth() + 1);
            var day = pad(date.getDate());
            var hours = pad(date.getHours());
            var minutes = pad(date.getMinutes());
            var seconds = pad(date.getSeconds());
          
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        copyCode(text){
            // 复制指定文案到剪贴板
            navigator.clipboard.writeText(text).then(() => {
                showMessage('Copied successfully','success')
            }).catch(err => {
                showMessage('Copied failed','error')
            });
        },
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );

            if (targetCountry) {
                // 滚动到目标国家
                targetCountry.scrollIntoView({ block: 'start' });
            }
        },
        Spin(){
            Object.keys(this.prizeAll).forEach((key)=>{
                if(this.prizeAll[key]){
                    //指向哪个奖品停止
                    this.className = key
                }
            })
            setTimeout(()=>{
                //显示奖品
                this.popup = this.prizePopup = true
            },8300)

            setTimeout(() => {
                //恢复转盘
                this.className = ''
                //可再次抽奖
                this.isLottery=true
            }, 8600);
        },
        // cookie
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },
    },
    created(){
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true

        if(this.getCookie('_OXVA_Cheers_to_good_times_')){
            this.isLogin = true
            this.user.token = this.getCookie('_OXVA_Cheers_to_good_times_')

            this.getInfo()
        }

        //提前加载卡片图
        const preloadImages = () => {
            for(let z of this.allQuestions){
                const img = new Image();
                img.src = z.img;
            }
        };
        preloadImages()

        this.getCountry()
        this.getData()
    },
    mounted(){

        this.initRound();

        this.$nextTick(() => {
            this.initCardLayout();
        });

        // 绑定全局拖拽事件，避免鼠标移出卡片后中断拖拽
        document.addEventListener('mousemove', this.onDragMove);
        document.addEventListener('mouseup', this.endDrag);
        document.addEventListener('touchmove', this.onDragMove, { passive: false });
        document.addEventListener('touchend', this.endDrag);
        document.addEventListener('touchcancel', this.endDrag);

        function showUp(dom){
            gsap.from(dom,{
                y:'2rem',opacity:0,ease:'none',duration:0.5,
                scrollTrigger:{
                    trigger:dom,
                    start:'top bottom-=20%',
                    end:'+=0',
                }
            })
        }
        
        var wFlag = window.innerWidth>750

        $('.box2_item3').click(function(){
            document.querySelector(".box6").scrollIntoView({block: "start",behavior: "smooth"});
        })

        //box1
        ScrollTrigger.create({
            trigger:'.box1',
            start:wFlag?'top top+=5%':'top top+=6%',
            end:'+=30%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box1_bg img',{scale:0.5,opacity:0,stagger:{each: 0.1,from: "end"},ease:'none'})
                .from('.box1_icon1',{x:wFlag?'25rem':'8rem',y:wFlag?'8rem':'-5rem',scale:0.5})
                .from('.box1_icon2',{x:wFlag?'25rem':'-8rem',y:wFlag?'-10rem':'4rem',scale:0.5},'<')
                .from('.box1_icon3',{x:wFlag?'-21rem':'-4rem',y:wFlag?'14rem':'6rem',scale:0.5},'<')
        })
        ScrollTrigger.create({
            trigger:'.box1',
            start:wFlag?'top top+=5%':'top top+=6%',
            end:'+=50%',
            pin:true,
        })

        //box2
        gsap.registerPlugin(SplitText,ScrollTrigger)
        SplitText.create(".box2_title", {
            type: "chars", //words
            autoSplit: true,
            charsClass:"chars++",
            onSplit(self) {
                return gsap.from(self.chars, {
                    y: 100,
                    opacity: 0,
                    //duration: 0.7, 
                    ease: "power4",
                    stagger: 0.05,
                    scrollTrigger:{
                        trigger:'.box2',
                        start:'top bottom-=20%',
                        end:'+=0',
                        toggleActions:'play none none reverse',
                    }
                });
            }
        });
        if(wFlag){
            ScrollTrigger.create({
                trigger:'.box2',
                start:'top top+=25%',
                end:'+=0%',
                //toggleActions:'play none none reverse',
                animation:gsap.timeline()
                    .from('.box2_bg',{opacity:0})
                    .from('.box2Swiper .swiper-wrapper .swiper-slide:nth-child(1)',{x:'106%'})
                    .from('.box2Swiper .swiper-wrapper .swiper-slide:nth-child(3)',{x:'-106%'},'<')
            })
        }else{
            new Swiper('.box2Swiper', {
                //autoplay: true,
                slidesPerView: 1.5,
                centeredSlides: true,
            })
        }

        //box6
        SplitText.create(".box6_title", {
            type: "chars",
            autoSplit: true,
            charsClass: "chars++",
            onSplit(self) {
                return gsap.from(self.chars, {
                    y: 100,
                    opacity: 0,
                    ease: "power4.out",
                    stagger: 0.05,
                    scrollTrigger: {
                        trigger: ".box6",
                        start: "top bottom-=20%",
                        //toggleActions: "play none none reverse"
                    },
                    onComplete() {
                        gsap.to(".box6_text2",{opacity: 1});
                    }
                });
            }
        });
        if(wFlag){
            ScrollTrigger.create({
                trigger:'.box6',
                start:'top center',
                end:'+=0%',
                toggleActions:'play none none reverse',
                animation:gsap.timeline()
                    .from('.cards-stage',{opacity:0,y:'2rem'})
                    .from('.momoBefore',{opacity:0,x:'30%',scale:0.6})
            })

            ScrollTrigger.create({
                trigger:'.box6',
                start:'top top+=4%',
                end:'+=40%',
                pin:true,
                anticipatePin: 1,
            })
        }else{
            showUp('.cards-stage')
        }

        //box4
        if(!wFlag){
            showUp('.box4_title')
        }
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top center-=20%',
            end:'+=0',
            animation:gsap.timeline()
                .from('.box4_text',{opacity:0,y:'6rem'})
        })

        //box5
        if(wFlag){
            new Swiper('.box5Swiper1', {
                speed:12000,
                autoplay: {
                  delay: 0,
                  disableOnInteraction: false,
                  //waitForTransition: false,
                },
                slidesPerView:6,
                loop:true
            })
    
            new Swiper('.box5Swiper2', {
                speed:12000,
                autoplay: {
                  delay: 0,
                  disableOnInteraction: false,
                  reverseDirection: true
                  //waitForTransition: false,
                },
                slidesPerView:6,
                loop:true
            })
        }else{
            var box5Flag = true
            $('.box5_bottom div p').click(function(){
                if(box5Flag){
                    $(this).text('Show Less')
                    $('.box5_bottom img:nth-child(n+7)').show()
                }else{
                    $(this).text('View More')
                    $('.box5_bottom img:nth-child(n+7)').hide()
                }
                box5Flag = !box5Flag
            })
        }
    },
    beforeDestroy: function () {
        document.removeEventListener('mousemove', this.onDragMove);
        document.removeEventListener('mouseup', this.endDrag);
        document.removeEventListener('touchmove', this.onDragMove);
        document.removeEventListener('touchend', this.endDrag);
        document.removeEventListener('touchcancel', this.endDrag);
        window.clearTimeout(this.resultTimer);
    },
})